module.exports = __webpack_public_path__ + "img/icon_tupianmoshi.476a468c.svg";